import { IActivityTypes } from '@/types/activity-log.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const updateMostRecentActivityReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action?: PayloadAction<{ isPublish: boolean }>) => {
    state.mostRecentActivityLogUpdate = new Date().toISOString();
    // It currently doesn't matter what type this. It's either a publish action, or anything else.
    state.mostRecentActivityLogType = action?.payload.isPublish
      ? IActivityTypes.published_events
      : IActivityTypes.events;
  });
};

export default updateMostRecentActivityReducer;
